import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  return (
    <div className={`inline-block ${className}`}>
      <div
        className={`animate-spin rounded-full border-2 border-gray-300 border-t-[#7a2c2c] ${sizeClasses[size]}`}
        role="status"
        aria-label="Yükleniyor"
      >
        <span className="sr-only">Yükleniyor...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;